
























import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import { getPropertyTranslation } from '../../../../../../../../../BotProperties/utils'
import { RemovePropertiesProxy } from '../../../logic/Actions/RemoveProperties/RemovePropertiesProxy'

@Component({
  data() {
    return {
      snakeCase
    }
  }
})
export default class RemovePropertiesActionNode extends Vue {
  @Prop() action!: RemovePropertiesProxy

  @Prop() i18n!: i18n

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  get beautifyProperties() {
    return this.action.action.identifiers
      .map((id) => {
        const property = this.getProperties().find(p => p.id === id)

        if (property) {
          return getPropertyTranslation(this.i18n, property.name ?? property.type)
        } else {
          return id
        }
      })
  }
}
